import React, { ChangeEvent, useEffect, useRef, useState } from "react";
import { Colors } from "../utils/style";
import {
  Alert,
  Button,
  Card,
  Form,
  Placeholder,
  Spinner,
} from "react-bootstrap";
import CardComponent from "./CardComponent";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCommentDots,
  faGear,
  faHandsAslInterpreting,
} from "@fortawesome/free-solid-svg-icons";
import { useStore } from "../store";
import axios from "axios";
import CodeCardComponent from "./CodeCardComponent";
import QuestionCardComponent from "./QuestionCardComponent";
import AnswerCardComponent from "./AnswerCardComponent";
import { useTranslation } from 'react-i18next';
import i18n from "../i18n";
import CreditModal from "./CreditModal";
import { axiosInstance } from "../App";
interface Props {
  fileName: string | null;
}

function ChatContainer(props: Props) {
  const { explanations, setExplanations } = useStore();
  const { visualisation, setVisualisation } = useStore();
  const { instructions, setInstructions } = useStore();
  const { interpretations, setIinterpretations } = useStore();

  const [loading, setLoading] = useState(false);
  const [uploadError, setUploadError] = useState(false);
  const [inputValue, setInputValue] = useState<string>("");
  const [questionsAndAnswer, setQuestionsAndAnswer] = useState<
    { question: string; data: JSON | undefined, answer: string | undefined }[] | undefined
  >(undefined);
  const [lastQuestion, setLastQuestion] = useState<string | undefined>(
    undefined
  );
  const [isModalOpen, setIsModalOpen] = useState(false);
  const chatCardRef = useRef<HTMLDivElement>(null);

  const { t } = useTranslation("ChatContainer");

  function handleSendButtonClick() {
    questionsAndAnswer === undefined
      ? setQuestionsAndAnswer([{ question: inputValue, data: undefined, answer: undefined }])
      : setQuestionsAndAnswer([
          ...questionsAndAnswer,
          { question: inputValue, data: undefined, answer: undefined },
        ]);
    setLastQuestion(inputValue);

    props.fileName && getAnswer(inputValue, "1", props.fileName);
    setInputValue("");
  }

function  getAnswer(
    question: string,
    conversationID: string,
    fileName: string
  ) {
  const body = {
    question: question,
    conversation_id: conversationID,
    filename: fileName,
  };
  setLoading(true);
  axiosInstance
    .post(process.env.REACT_APP_API_HOST + "answer_from_data", body, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("tokenLida"),
        "Accept-Language": i18n.language, // Add current language
      },
    })
    .then((response) => {
      const { answer, data } = response.data;

      const newEntry = {
        question: question,
        answer: answer,
        data: data, // Add data here
      };

      if (questionsAndAnswer && questionsAndAnswer.length > 0) {
        setQuestionsAndAnswer([...questionsAndAnswer, newEntry]);
      } else {
        setQuestionsAndAnswer([newEntry]);
      }

      setLastQuestion(undefined);
      setLoading(false);
      setUploadError(false);
    })
    .catch((error) => {
      setLoading(false);
      setUploadError(true);
      setLastQuestion(undefined);
      console.error("Error uploading file:", error);

      if (error.response && error.response.status === 402) {
        // Show payment modal
        setIsModalOpen(true);
      }
    });
}

















  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
  };
  useEffect(() => {
    if (chatCardRef.current) {
      chatCardRef.current.scrollTo({
        top: chatCardRef.current.scrollHeight,
        behavior: "auto",
      });
    }
  }, [lastQuestion]);

  return (
    <>
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "1rem",
      }}
    >
      {questionsAndAnswer && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            color: Colors.DARK_GRAY,
            maxHeight: "20rem",
            overflow: "auto",
          }}
          ref={chatCardRef}
        >
          <Card
            style={{
              width: "100%",
              backgroundColor: "#e5e4e2",
              height: "100%",
            }}
          >
            <Card.Body
              style={{
                color: Colors.DARK_GRAY,
              }}
            >
              {questionsAndAnswer.map((q, index) => (
                <div key={index}>
                  <QuestionCardComponent
                    question={q.question}
                  ></QuestionCardComponent>
                  {loading && index === questionsAndAnswer.length - 1 ? (
                    <div
                      className="mt-3"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Spinner animation="grow" variant="success" />
                    </div>
                  ) : uploadError && index === questionsAndAnswer.length - 1 ? (
                    <></>

                  ) : (
                    <AnswerCardComponent
                      answer={q.answer}
                    ></AnswerCardComponent>
                  )}
                </div>
              ))}
            </Card.Body>
          </Card>
        </div>
      )}
      <Form
        style={{
          display: "flex",
          height: "3rem",
          gap: "1rem",
          margin: "1rem",
        }}
        onSubmit={(e) => {
          e.preventDefault();
          handleSendButtonClick();
        }}
      >
        <Form.Control
          type="text"
          placeholder={t("PlaceholderText")}
          value={inputValue}
          onChange={handleInputChange}
          style={{ borderColor: "green" }}
        />

        <Button variant="success" onClick={handleSendButtonClick}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "0.5rem",
            }}
          >
            <FontAwesomeIcon icon={faGear} size="1x" />
            <div>{t("SendButton")} </div>
          </div>
        </Button>
      </Form>
    </div>


    </>
  );
}

export default ChatContainer;
